import { Factory } from 'miragejs';

const SUBSCRIPTION_PLANS = [
  {
    id: 'deliveries-basic',
    app: 'deliveries',
    name: 'Basic',
    level: 'basic',
    period: 'weekly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'deliveries-standard-monthly',
    app: 'deliveries',
    name: 'Premium',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 35900,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'deliveries-standard-yearly',
    app: 'deliveries',
    name: 'Premium',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 29900,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'rooms-basic',
    app: 'rooms',
    name: 'Standard',
    level: 'standard',
    period: 'weekls',
    rank: 0,
    price: 0,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'rooms-standard-monthly',
    app: 'rooms',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 2100,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'rooms-standard-yearly',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 1800,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'visitors-basic-weekly',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'visitors-standard-monthly',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 11900,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'visitors-standard-yearly',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 9900,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'visitors-premium-monthly',
    app: 'visitors',
    name: 'Premium',
    level: 'premium',
    period: 'monthly',
    rank: 20,
    price: 35900,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'visitors-premium-yearly',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 29900,
    sequence: 0,
    available: false,
    alternateId: null,
  },
  {
    id: 'visitors-enterprise-monthly',
    app: 'visitors',
    name: 'Enterprise',
    level: 'enterprise',
    period: 'monthly',
    rank: 40,
    price: 99900,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'visitors-enterprise-yearly',
    app: 'visitors',
    name: 'Enterprise',
    level: 'enterprise',
    period: 'yearly',
    rank: 40,
    price: 12900,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  // Deliveries
  {
    id: 'deliveries-basic-monthly-calendar-billing',
    app: 'deliveries',
    name: 'Basic',
    level: 'basic',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: 'deliveries-basic-yearly-calendar-billing',
  },
  {
    id: 'deliveries-basic-yearly-calendar-billing',
    app: 'deliveries',
    name: 'Basic',
    level: 'basic',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: 'deliveries-basic-monthly-calendar-billing',
  },
  {
    id: 'deliveries-standard-monthly-calendar-billing',
    app: 'deliveries',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 19900,
    sequence: 1,
    available: true,
    alternateId: 'deliveries-standard-yearly-calendar-billing',
  },
  {
    id: 'deliveries-standard-yearly-calendar-billing',
    app: 'deliveries',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 15900,
    sequence: 1,
    available: true,
    alternateId: 'deliveries-standard-monthly-calendar-billing',
  },
  // Rooms
  {
    id: 'rooms-basic-monthly-calendar-billing',
    app: 'rooms',
    name: 'Basic',
    level: 'basic',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: 'rooms-basic-yearly-calendar-billing',
  },
  {
    id: 'rooms-basic-yearly-calendar-billing',
    app: 'rooms',
    name: 'Basic',
    level: 'basic',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: 'rooms-basic-monthly-calendar-billing',
  },
  {
    id: 'rooms-standard-monthly-calendar-billing',
    app: 'rooms',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 2100,
    sequence: 1,
    available: true,
    alternateId: 'rooms-standard-yearly-calendar-billing',
  },
  {
    id: 'rooms-standard-yearly-calendar-billing',
    app: 'rooms',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 1800,
    sequence: 1,
    available: true,
    alternateId: 'rooms-standard-monthly-calendar-billing',
  },
  // Visitors
  {
    id: 'visitors-basic-monthly-calendar-billing',
    app: 'visitors',
    name: 'Basic',
    level: 'basic',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 3,
    available: true,
    alternateId: 'visitors-basic-yearly-calendar-billing',
  },
  {
    id: 'visitors-basic-yearly-calendar-billing',
    app: 'visitors',
    name: 'Basic',
    level: 'basic',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 3,
    available: true,
    alternateId: 'visitors-basic-monthly-calendar-billing',
  },
  {
    id: 'visitors-standard-monthly-calendar-billing',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 11900,
    sequence: 0,
    available: true,
    alternateId: 'visitors-standard-yearly-calendar-billing',
  },
  {
    id: 'visitors-standard-yearly-calendar-billing',
    app: 'visitors',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 9900,
    sequence: 0,
    available: true,
    alternateId: 'visitors-standard-monthly-calendar-billing',
  },
  {
    id: 'visitors-premium-monthly-calendar-billing',
    app: 'visitors',
    name: 'Premium',
    level: 'premium',
    period: 'monthly',
    rank: 20,
    price: 35900,
    sequence: 1,
    available: true,
    alternateId: 'visitors-premium-yearly-calendar-billing',
  },
  {
    id: 'visitors-premium-yearly-calendar-billing',
    app: 'visitors',
    name: 'Premium',
    level: 'premium',
    period: 'yearly',
    rank: 20,
    price: 29900,
    sequence: 1,
    available: true,
    alternateId: 'visitors-premium-monthly-calendar-billing',
  },
  {
    id: 'visitors-enterprise-monthly-calendar-billing',
    app: 'visitors',
    name: 'Enterprise',
    level: 'enterprise',
    period: 'monthly',
    rank: 30,
    price: 129000,
    sequence: 2,
    available: true,
    alternateId: 'visitors-enterprise-yearly-calendar-billing',
  },
  {
    id: 'visitors-enterprise-yearly-calendar-billing',
    app: 'visitors',
    name: 'Enterprise',
    level: 'enterprise',
    period: 'yearly',
    rank: 30,
    price: 99900,
    sequence: 2,
    available: true,
    alternateId: 'visitors-enterprise-monthly-calendar-billing',
  },
  // Desks
  {
    id: 'desks-basic-monthly-calendar-billing',
    app: 'desks',
    name: 'Basic',
    level: 'basic',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: 'desks-basic-yearly-calendar-billing',
  },
  {
    id: 'desks-basic-yearly-calendar-billing',
    app: 'desks',
    name: 'Basic',
    level: 'basic',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: 'desks-basic-monthly-calendar-billing',
  },
  {
    id: 'desks-standard-monthly-calendar-billing',
    app: 'desks',
    name: 'Standard',
    level: 'standard',
    period: 'monthly',
    rank: 10,
    price: 10000,
    sequence: 1,
    available: true,
    alternateId: 'desks-standard-yearly-calendar-billing',
  },
  {
    id: 'desks-standard-yearly-calendar-billing',
    app: 'desks',
    name: 'Standard',
    level: 'standard',
    period: 'yearly',
    rank: 10,
    price: 7500,
    sequence: 1,
    available: true,
    alternateId: 'desks-standard-monthly-calendar-billing',
  },
  // Workplace
  {
    id: 'empxp-standard-monthly',
    app: 'empxp',
    name: 'Workplace Standard Monthly',
    level: 'standard',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'empxp-standard-quarterly',
    app: 'empxp',
    name: 'Workplace Standard Quarterly',
    level: 'standard',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'empxp-standard-yearly',
    app: 'empxp',
    name: 'Workplace Standard Yearly',
    level: 'standard',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'empxp-premium-monthly',
    app: 'empxp',
    name: 'Workplace Premium Monthly',
    level: 'premium',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'empxp-premium-quarterly',
    app: 'empxp',
    name: 'Workplace Premium Quarterly',
    level: 'premium',
    period: 'monthly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'empxp-premium-yearly',
    app: 'empxp',
    name: 'Workplace Premium Yearly',
    level: 'premium',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
  {
    id: 'empxp-premium-plus-yearly',
    app: 'empxp',
    name: 'Workplace Premium Plus Yearly',
    level: 'premium-plus',
    period: 'yearly',
    rank: 0,
    price: 0,
    sequence: 0,
    available: true,
    alternateId: null,
  },
];

export default Factory.extend({
  id(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].id;
  },

  app(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].app;
  },

  name(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].name;
  },

  level(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].level;
  },

  period(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].period;
  },

  rank(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].rank;
  },

  price(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].price;
  },

  sequence(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].sequence;
  },

  available(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].available;
  },

  /*
    Ugly workaround comming up:
    We cant associate alternate if the related plan is not yet created,
    so we store the alternateId as a temp and we associate it
    after the list is created.
  */
  tempAlternateId(i) {
    return SUBSCRIPTION_PLANS[i % SUBSCRIPTION_PLANS.length].alternateId;
  },
});
